(function () {
  function initDevelopmentProcess(section) {
    if (!section || section.dataset.initialized === 'true') return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('.development-process-2026__tab'));
    var cardsWrap = section.querySelector('[data-cards-wrap]');
    var cards = cardsWrap ? Array.prototype.slice.call(cardsWrap.querySelectorAll('[data-card]')) : [];
    var dialZone = section.querySelector('.development-process-2026__dial-zone');
    var dialRotor = section.querySelector('[data-dial-rotor]');
    var yearWindow = section.querySelector('[data-year-window]');
    var prevYearBtn = section.querySelector('[data-year-jump="prev"]');
    var nextYearBtn = section.querySelector('[data-year-jump="next"]');
    var contentJson = section.querySelector('[data-development-process-content]');

    if (!tabs.length || !cards.length || !dialZone || !dialRotor || !yearWindow || !contentJson) return;

    var content = [];
    try {
      content = JSON.parse(contentJson.textContent || '[]');
    } catch (error) {
      content = [];
    }
    if (!content.length) return;

    var rotationStep = parseFloat(section.getAttribute('data-rotation-step') || '28');
    if (!isFinite(rotationStep) || rotationStep <= 0) rotationStep = 28;

    var currentIndex = 0;
    var currentAngle = 0;
    var yearAnimationToken = 0;
    var yearCleanupTimer = null;

    function setActiveTab(index) {
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function updateCards(nextData) {
      cardsWrap.classList.add('is-changing');

      window.setTimeout(function () {
        cards.forEach(function (card, cardIndex) {
          card.innerHTML = (nextData.cards && nextData.cards[cardIndex] ? nextData.cards[cardIndex] : '').replace(/\n/g, '<br>');
        });
        if (nextData.cardDotLeft1) {
          cards[0].style.setProperty('--card-dot-left-1', nextData.cardDotLeft1);
        } else {
          cards[0].style.removeProperty('--card-dot-left-1');
        }
        if (nextData.cardDotLeft3) {
          cards[2].style.setProperty('--card-dot-left-3', nextData.cardDotLeft3);
        } else {
          cards[2].style.removeProperty('--card-dot-left-3');
        }
        if (nextData.yearFontSize) {
          yearWindow.style.setProperty('--year-font-size', nextData.yearFontSize);
        } else {
          yearWindow.style.removeProperty('--year-font-size');
        }
      }, 140);

      window.setTimeout(function () {
        cardsWrap.classList.remove('is-changing');
      }, 360);
    }

    function animateYear(nextYear, direction) {
      yearAnimationToken += 1;
      var token = yearAnimationToken;

      if (yearCleanupTimer) {
        window.clearTimeout(yearCleanupTimer);
      }

      var existingYears = Array.prototype.slice.call(yearWindow.querySelectorAll('[data-year-number]'));
      var oldEl = existingYears.length ? existingYears[existingYears.length - 1] : null;

      for (var i = 0; i < existingYears.length - 1; i++) {
        if (existingYears[i].parentNode) {
          existingYears[i].parentNode.removeChild(existingYears[i]);
        }
      }

      if (!oldEl) {
        var fallbackEl = document.createElement('span');
        fallbackEl.className = 'development-process-2026__year-number';
        fallbackEl.setAttribute('data-year-number', '');
        fallbackEl.innerHTML = (nextYear || '').replace(/\n/g, '<br>');
        yearWindow.appendChild(fallbackEl);
        return;
      }

      var newEl = document.createElement('span');
      newEl.className = 'development-process-2026__year-number';
      newEl.setAttribute('data-year-number', '');
      newEl.innerHTML = (nextYear || '').replace(/\n/g, '<br>');
      newEl.classList.add('is-fade-enter');

      yearWindow.appendChild(newEl);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (token !== yearAnimationToken) return;

          oldEl.classList.add('is-fade-exit');
          newEl.classList.remove('is-fade-enter');
        });
      });

      yearCleanupTimer = window.setTimeout(function () {
        if (token !== yearAnimationToken) {
          if (newEl.parentNode) newEl.parentNode.removeChild(newEl);
          return;
        }

        var yearNodes = Array.prototype.slice.call(yearWindow.querySelectorAll('[data-year-number]'));
        yearNodes.forEach(function (node) {
          if (node !== newEl && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
      }, 390);
    }

    function updateAdjacentYearButtons(nextData, nextIndex, withFade) {
      if (!prevYearBtn || !nextYearBtn) return;

      function applyButtonState(button, text, disabled, animate) {
        var finalText = text || '';
        if (animate) {
          button.classList.add('is-fading');
          window.setTimeout(function () {
            button.textContent = finalText;
            button.disabled = !!disabled;
            button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            button.classList.remove('is-fading');
          }, 120);
        } else {
          button.textContent = finalText;
          button.disabled = !!disabled;
          button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
      }

      applyButtonState(prevYearBtn, nextData.prevYearText, nextIndex >= content.length - 1, withFade);
      applyButtonState(nextYearBtn, nextData.nextYearText, nextIndex <= 0, withFade);
    }

    function rotateDial(direction, stepCount) {
      var turn = rotationStep * (stepCount || 1);
      if (direction > 0) {
        currentAngle -= turn;
      } else {
        currentAngle += turn;
      }
      dialRotor.style.transform = 'translate(-62%, -50%) rotate(' + currentAngle + 'deg)';
    }

    function activateTab(nextIndex, fromKeyboardFocus) {
      if (nextIndex < 0 || nextIndex >= content.length || nextIndex === currentIndex) return;

      var delta = nextIndex - currentIndex;
      var direction = delta > 0 ? 1 : -1;
      var stepCount = Math.abs(delta);
      var nextData = content[nextIndex];

      setActiveTab(nextIndex);
      animateYear(nextData.year, direction);
      rotateDial(direction, stepCount);
      updateCards(nextData);
      updateAdjacentYearButtons(nextData, nextIndex, true);

      currentIndex = nextIndex;

      if (fromKeyboardFocus) {
        tabs[nextIndex].focus();
      }
    }

    function stepTab(step) {
      var nextIndex = currentIndex + step;
      if (nextIndex < 0 || nextIndex >= content.length) return;
      activateTab(nextIndex, false);
    }

    function bindDialSwipe() {
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var swipeLocked = false;
      var swipeThreshold = 26;
      var swipeCooldownMs = 320;

      dialZone.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          var touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          tracking = true;
        },
        { passive: false }
      );

      dialZone.addEventListener(
        'touchmove',
        function (event) {
          if (!tracking || swipeLocked || !event.touches || !event.touches.length) return;

          event.preventDefault();

          var touch = event.touches[0];
          var deltaX = touch.clientX - startX;
          var deltaY = touch.clientY - startY;
          var absX = Math.abs(deltaX);
          var absY = Math.abs(deltaY);

          if (absY < swipeThreshold || absY <= absX) return;

          tracking = false;
          swipeLocked = true;

          if (deltaY < 0) {
            stepTab(1);
          } else {
            stepTab(-1);
          }

          window.setTimeout(function () {
            swipeLocked = false;
          }, swipeCooldownMs);
        },
        { passive: false }
      );

      dialZone.addEventListener('touchend', function () {
        tracking = false;
      });

      dialZone.addEventListener('touchcancel', function () {
        tracking = false;
      });
    }

    function bindEvents() {
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(index, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            nextIndex = (index + 1) % tabs.length;
            activateTab(nextIndex, true);
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            activateTab(nextIndex, true);
          }
        });
      });

      if (prevYearBtn) {
        prevYearBtn.addEventListener('click', function () {
          stepTab(1);
        });
      }

      if (nextYearBtn) {
        nextYearBtn.addEventListener('click', function () {
          stepTab(-1);
        });
      }

      bindDialSwipe();
    }

    function initDefaultContent() {
      var defaultData = content[0];
      cards.forEach(function (card, cardIndex) {
        card.innerHTML = (defaultData.cards && defaultData.cards[cardIndex] ? defaultData.cards[cardIndex] : '').replace(/\n/g, '<br>');
      });
      if (defaultData.cardDotLeft1) {
        cards[0].style.setProperty('--card-dot-left-1', defaultData.cardDotLeft1);
      }
      if (defaultData.cardDotLeft2) {
        cards[1].style.setProperty('--card-dot-left-2', defaultData.cardDotLeft2);
      }
      if (defaultData.cardDotLeft3) {
        cards[2].style.setProperty('--card-dot-left-3', defaultData.cardDotLeft3);
      }
      if (defaultData.yearFontSize) {
        yearWindow.style.setProperty('--year-font-size', defaultData.yearFontSize);
      }
      setActiveTab(0);
      updateAdjacentYearButtons(defaultData, 0, false);
      dialRotor.style.transform = 'translate(-62%, -50%) rotate(0deg)';
    }

    bindEvents();
    initDefaultContent();
    section.dataset.initialized = 'true';
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.development-process-2026');
    sections.forEach(initDevelopmentProcess);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId) {
      var section = document.getElementById('ShopifySection-' + event.detail.sectionId);
      if (section) {
        initDevelopmentProcess(section);
      }
    }
  });
})();
